import { motion } from "framer-motion";
import partner from "../assets/images/xpel.png";

const PartnersSection = () => {
  return (
    <div className="flex flex-col items-center py-[100px] max-w-[100vw]">
      <motion.h2
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{
          duration: 1,
          delay: 0.4,
        }}
        className="uppercase text-white text-[25px] sm:text-[38px] md:text-[48px] border-white border-[4px] sm:border-[6px] md:border-[8px] !border-r-0 !border-t-0 px-[5px] sm:px-[10px] md:px-[15px] font-extrabold"
      >
        AUTHORIZED <span className="text-yellow">Dealer</span>
      </motion.h2>
      <a href="www.xpel.com">
        <motion.img
          initial={{ y: 50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{
            duration: 0.6,
            delay: 0.4,
            damping: 10,
            mass: 0.75,
            stiffness: 100,
          }}
          className="w-[200px] md:w-[300px] mt-[20px] cursor-pointer hover:scale-110 duration-300"
          src={partner}
        />
      </a>
    </div>
  );
};

export default PartnersSection;
